
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";

import useFetch from "../../helpers/useFetch";
import BiButton from "../../uic/controls/BiButton";
import BiLabel from "../../uic/controls/BiLabel";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid"
import { useNavigate } from 'react-router-dom';
import StatusObrazca from "../Obrazci/StatusObrazca";
import BiFormTable from '../../uic/formTable/BiFormTable';
import BiFormRow from '../../uic/formTable/BiFormRow';
import BiFormCell from '../../uic/formTable/BiFormCell';
import BiFormSection from '../../uic/formTable/BiFormSection';
import BiCheckBoxList from "../../uic/controls/BiCheckBoxList";
import authService from '../../api-authorization/AuthorizeService'
import { httpGet, httpPost } from "../../helpers/httpHelper";
import PrijavniObrazec from "../Obrazci/PrijavniObrazec";
import BiFileUpload from "../../uic/controls/BiFileUpload";
import yesno from 'yesno-dialog'


const PrijavaStranka = (props) => {
    const navigate = useNavigate();
    const { sessionReady, sessionData, setLoading, toastError, toastOK, setHelpMainKey } = useContext(SessionContext);

    const [tipPogleda, setTipPogleda] = useState(1);
    const [napakeList, setNapakeList] = useState(null);
    const [data, setData] = useState(null);

    const dodajPrijavo = (tip) => {
        //console.log(sessionData);
        //console.log("Prijava");
        setLoading(true);
        httpGet(
            "api/prijava/GetPrijavaObrazec",
            {
                PIdTipObrazca: tip,
                UserID: sessionData?.user?.id
            },
            (ret) => {
                console.log(ret);
                setTipPogleda(2);
                setData(ret);
                setLoading(false);
            },
            null);
    }

    const preveriObrazec = () => {
        var napake = "";
        if (!data.obrazecDetail.naziv) {
            napake += "<li>Naziv</li>";
        }
        if (!data.obrazecDetail.naslov) {
            napake += "<li>Naslov</li>";
        }
        if (!data.obrazecDetail.email) {
            napake += "<li>Email</li>";
        }
        if (!data.obrazecDetail.davcnaStevilka) {
            napake += "<li>Davčna številka</li>";
        }
        if (!data.obrazecDetail.postaSif.id) {
            napake += "<li>Pošta</li>";
        }
        if (!data.obrazecDetail.mobilniTelefon && !data.obrazecDetail.telefon) {
            napake += "<li>Telefon ali mobilni telefon</li>";
        }

        if (data.obrazec.pIdTipObrazca == 6) {
            if (!data.obrazecDetail.pridelavaMleka && !data.obrazecDetail.pridelavaSadja && !data.obrazecDetail.rejaZivali && !data.obrazecDetail.distribucija && !data.obrazecDetail.trzenje && !data.obrazecDetail.predelavaMleka && !data.obrazecDetail.predelavaSadja && !data.obrazecDetail.obrat && !data.obrazecDetail.oznacbaIk && !data.obrazecDetail.drugo) {
                napake += "<li>Izberite vsaj en parameter izbrane kakovosti.</li>";
            }
        }

        if (data.obrazec.pIdTipObrazca == 1) {
            var chK = data.obrazecDetail.kategorijeIzbira.filter(o => o.izbran == true).length;
            if (chK == 0) {
                napake += "<li>Izberite vsaj eno kategorijo</li>";
            }
            var chD = data.obrazecDetail.dejavnostiIzbira.filter(o => o.izbran == true).length;
            if (chK == 0) {
                napake += "<li>Izberite vsaj eno dejavnost</li>";
            }
        }
        if (data.obrazec.pIdTipObrazca == 4) {
            
            var chP = data.obrazecDetail.polscine.filter(o => o.kolicina > 0).length;
            if (chP == 0) {
                napake += "<li>Izpolnite vsaj eno vrstico v način pridelave. Vpisati morate tudi površino.</li>";
            }
        }

        if (data.obrazec.pIdTipObrazca == 5) {

            var chPr = data.obrazecDetail.dejavnostizpz.filter(o => o.pridelek != null).length;
            if (chPr == 0) {
                napake += "<li>Izpolnite vsaj eno vrstico v pridelek ali živilo.</li>";
            }
        }

        if (napake) {
            setNapakeList("<ul>" + napake + "</ul>");
        } else {
            setNapakeList(null);
        }
        return !napake;
    }

    const posljiPrijavo = async () => {

        var btext = "";
        if (!data.obrazecDetail.kmgMid) {
            btext = "Ali ste prepričani da želite oddati prijavo brez KMG-MID?";
        }
        else { btext = "Ali ste prepričani da želite oddati prijavo?"; }
        const yes = await yesno({
            labelYes: "Da",
            labelNo: "Ne",
            bodyText: btext
        });

        if (yes == true) {

            if (preveriObrazec()) {
                setLoading(true);
                

                httpPost(
                    "api/prijava/posljiObrazec",
                    {
                        body: JSON.stringify(
                            { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail) }
                        ),
                        UserID: sessionData?.user?.id
                    },
                    (ret) => {
                        if (ret.success) {

                            toastOK("Uspešno!");
                            setTipPogleda(3);
                            setData(null);
                        } else {
                            toastError(ret.message);
                        }
                        setLoading(false);
                    },
                    null);
            }
        }
    }

    const onObrazecMainDatotekaAdd = (datoteka, name) => {
        console.log(datoteka);
        setData(prevState => ({
            ...prevState,
            obrazec: {
                ...prevState.obrazec,
                [name]: prevState.obrazec[name].concat(datoteka),
                changed: true
            }
        }));
    }

    const onObrazecMainDatotekaRemove = (PIdDatoteke, name) => {
        console.log(PIdDatoteke)
        setData(prevState => ({
            ...prevState,
            obrazec: {
                ...prevState.obrazec,
                [name]: prevState.obrazec[name].filter(pr => pr.pIdDatoteke != PIdDatoteke),
                changed: true
            }
        }));
    }

    const onObrazecChanged = (e) => {
        const { name, value } = e.target;
        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: value,
                changed: true
            }
        }));
    }

    const onObrazecTableChange = (e, name, mainKey, item1) => {

        console.log("changed", e, name, mainKey, item1);
        const { value } = e.target;


        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: prevState.obrazecDetail[name].map(ch =>
                    ch[mainKey] === item1[mainKey] ? { ...ch, [e.target.name]: e.target.value, changed: true } : ch
                ),
                changedChildren: true,
                changed: true
            }
        }));
    }
 
    const onObrazecCBListChanged = (checked, name, items, item) => {

        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: items.map(ch =>
                    ch.id === item.id ? { ...ch, izbran: checked } : ch
                ),
                changedChildren: true,
                changed: true
            }
        }));
    }





    return (

        <Fragment >



            {tipPogleda == 1 &&
                <div>
                    <h4 style={{ marginBottom: "30px" }} >Prijava nove stranke</h4>

                    <table className="table table-bordered table-striped tabelaPrijava">
                        <thead>
                            <tr>
                                <td>Shema certificiranja</td>
                                <td>Opis sheme</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>

                            <tr>
                                <td>Prijava v shemo ekološko kmetovanje (EKO) (kmetijsko gospodarstvo, dopolnilna dejavnost na kmetiji)</td>
                                <td><a href="https://www.kon-cert.si/sheme-certificiranja/ekolosko-kmetovanje/" target="_blank">Opis sheme</a></td>
                                <td><BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => dodajPrijavo(1)}  >Začni</BiButton></td>
                            </tr>

                            {/*<tr>*/}
                            {/*    <td>Prijava v shemo ekološka predelava (EPR)</td>*/}
                            {/*    <td><a href="https://www.kon-cert.si/sheme-certificiranja/ekoloska-predelava/" target="_blank">Opis sheme</a></td>*/}
                            {/*    <td><BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => dodajPrijavo(7)}  >Začni</BiButton></td>*/}
                            {/*</tr>*/}

                            <tr>
                                <td>Prijava v shemo integrirana pridelava (IP)</td>
                                <td><a href="https://www.kon-cert.si/sheme-certificiranja/integrirana-pridelava/" target="_blank" >Opis sheme</a></td>
                                <td><BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => dodajPrijavo(4)}  >Začni</BiButton></td>
                            </tr>

                            <tr>
                                <td>Prijava v shemo zaščitenih kmetijskih pridelkov oziroma živil (SENENA PRIREJA…)</td>
                                <td><a href="https://www.kon-cert.si/sheme-certificiranja/zasciteni-kmetijski-pridelki-in-zivila/" target="_blank">Opis sheme</a></td>
                                <td><BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => dodajPrijavo(5)}  >Začni</BiButton></td>
                            </tr>

                            <tr>
                                <td>Prijava v shemo izbrana kakovost (IK)</td>
                                <td><a href="https://www.kon-cert.si/sheme-certificiranja/izbrana-kakovost/" target="_blank">Opis sheme</a></td>
                                <td><BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => dodajPrijavo(6)}  >Začni</BiButton></td>
                            </tr>
                            <tr>
                                <td>Prijava v shemo ekološka predelava (EPR) (d.o.o., d.d., s.p., z.o.o., ...)</td>
                                <td><a href="https://www.kon-cert.si/sheme-certificiranja/ekoloska-predelava/" target="_blank">Opis sheme</a></td>
                                <td><BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => dodajPrijavo(7)}  >Začni</BiButton></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }

            {tipPogleda == 2 && data &&
                <Fragment>
                    
                    <div className="form-inline" style={{ margin: "5px 0px", width: "100%", display:"flex"}}>

                        {data.obrazec.pIdTipObrazca == 1 &&
                            <h4 style={{ width: "100%" }} >Prijava v shemo ekološko kmetovanje (EKO) (kmetijsko gospodarstvo, dopolnilna dejavnost na kmetiji)</h4>}
                        {/*{data.obrazec.pIdTipObrazca == 7 &&*/}
                        {/*    <h4 style={{ width: "100%" }} >Prijava v shemo ekološko kmetovanje (EPR)</h4>}*/}
                        {data.obrazec.pIdTipObrazca == 4 &&
                            <h4 style={{ width: "100%" }} >Prijava v shemo integrirana pridelava (IP)</h4>}
                        {data.obrazec.pIdTipObrazca == 5 &&
                            <h4 style={{ width: "100%" }} >Prijava v shemo zaščitenih kmetijskih pridelkov oziroma živil (SENENA PRIREJA…)</h4>}
                        {data.obrazec.pIdTipObrazca == 6 &&
                            <h4 style={{ width: "100%" }} >Prijava v shemo izbrana kakovost (IK)</h4>}
                        {data.obrazec.pIdTipObrazca == 7 &&
                            <h4 style={{ width: "100%" }} >Prijava v shemo ekološka predelava (EPR) (d.o.o., d.d., s.p., z.o.o., ...)</h4>}
                        <div style={{ textAlign:"right" , width:"200px"}} >
                            <BiButton className="btn-success" margin="4px 0" height="40px" icon="fas fa-paper-plane" onClick={posljiPrijavo} > Oddaj prijavo</BiButton>
                        </div>
                    </div>

                    {napakeList &&
                        <div style={{ color: "red", border: "1px solid red", padding: "2px 10px", borderRadius:"10px", marginBottom:"20px" }} >
                            <b>Seznam napak:</b>
                            <div dangerouslySetInnerHTML={{ __html: napakeList }} />
                        </div>}

                    <PrijavniObrazec
                        admin={false}
                        disabled={false}
                        obrazec={data.obrazecDetail}
                        onObrazecChanged={onObrazecChanged}
                        onObrazecCBListChanged={onObrazecCBListChanged}
                        onObrazecTableChange={onObrazecTableChange}
                    ></PrijavniObrazec>


                    <form className="form-inline">

                        <BiFormTable columns={[
                            { width: "100%" }
                        ]}>

                            <BiFormSection show={true} label="Datoteke (vse)" icon="fas fa-file">
                                <BiFormRow divider={true}></BiFormRow>
                                <BiFormRow>
                                    <BiFormCell colSpan="3">
                                        <div style={{ minHeight: "100px" }} >
                                            <BiFileUpload skipAuth={true} name="datoteke" readOnly={false} items={data.obrazec.datoteke} idObrazca={data.obrazec.pIdObrazca} tipiDatoteke={data.obrazec.tipiDatoteke} onAdd={onObrazecMainDatotekaAdd} onRemove={onObrazecMainDatotekaRemove} ></BiFileUpload>
                                        </div>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow divider={true}></BiFormRow>
                                <BiFormRow divider={true}></BiFormRow>
                            </BiFormSection>

                        </BiFormTable>
                    </form>
                </Fragment>
            }

            {tipPogleda == 3 &&
                <Fragment>
                    <div style={{ textAlign: "center", margin: "80px auto" }}>
                        <div style={{ border: "1px solid rgb(50, 180, 88)", padding: "10px", width: "400px", borderRadius:"10px", margin:"auto" }} >
                            <i className="fas fa-check" style={{ fontSize: "70px", textAlign: "center", color: "rgb(50, 180, 88)" }} ></i>
                            <h3 style={{ textAlign: "center", margin: "10px 20px", color: "rgb(50, 180, 88)", fontWeight:"normal" }} >Vaša prijava je uspešno oddana!</h3>
                        </div>
                        <BiButton  margin="50px 4px" icon="fas fa-arrow-left" onClick={() => setTipPogleda(1)}  >Nazaj na seznam</BiButton>
                    </div>
                </Fragment>
            }

        </Fragment>
    );

}

export default PrijavaStranka;